import * as React from 'react';
import { Link } from 'react-router-dom';

import { inject, observer } from 'mobx-react';

import { QueryRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';

import { UitkFakeInput } from 'uitk-react-input';

export interface SearchFormOptionsDialogWrapperProps {
  children: React.ReactNode;
  dialogId: string;
  label: string;
  labelIcon?: string;
  mobileClassNames?: string;
  routeStore?: RouteStore;
  subLabel?: string;
}

export const SearchFormOptionsDialogWrapper = inject('routeStore')(
  observer(
    ({
      children,
      dialogId,
      label,
      labelIcon,
      routeStore,
      subLabel,
      mobileClassNames
    }: SearchFormOptionsDialogWrapperProps) => {
      const moreFiltersNestedDialogQuery = routeStore.mergeQueryString(routeStore.search, {
        pwaDialog: dialogId
      });

      return (
        <>
          <Link className={mobileClassNames} to={{ search: moreFiltersNestedDialogQuery }}>
            <UitkFakeInput icon={labelIcon} label={subLabel} value={label} />
          </Link>
          <QueryRoute query={{ pwaDialog: dialogId }}>
            <Layer id={`${dialogId}-layer`}>{children}</Layer>
          </QueryRoute>
        </>
      );
    }
  )
);
